<template>
  <div
    class="flex items-center gap-4 rounded-lg border border-solid p-4 text-base wrap-break-word whitespace-normal"
    :class="classes[type]"
    :role="roles[type]"
    :aria-live="type === 'error' || type === 'warning' ? 'assertive' : 'polite'"
  >
    <component :is="icons[type]" aria-hidden="true" class="h-6! w-6! shrink-0" />
    <slot v-if="$slots.default" />
    <template v-else> {{ message }} </template>
  </div>
</template>

<script>
const types = {
  info: "info",
  success: "success",
  warning: "warning",
  error: "error",
};
</script>

<script setup>
import RfCheckIcon from "@/components/icons/RfCheckIcon.vue";
import RfStatusIcon from "@/components/icons/RfStatusIcon.vue";

const classes = {
  info: "border-blue-50! text-blue-50 [&_.rf-icon]:fill-blue-50! [&_.rf-icon]:stroke-blue-50! [&_.rf-icon]:rotate-180",
  success:
    "border-green-50! text-green-50 [&_.rf-icon]:fill-green-50! [&_.rf-icon]:stroke-green-50!",
  warning: "border-shade-3! text-shade-3 [&_.rf-icon]:fill-shade-3! [&_.rf-icon]:stroke-shade-3!",
  error: "border-red-1! text-red-1 [&_.rf-icon]:fill-red-1! [&_.rf-icon]:stroke-red-1!",
};

const icons = {
  info: RfStatusIcon,
  success: RfCheckIcon,
  warning: RfStatusIcon,
  error: RfStatusIcon,
};

const roles = {
  info: "status",
  success: "status",
  warning: "alert",
  error: "alert",
};

defineProps({
  message: { type: String, default: "This is an alert" },
  type: { type: String, default: types.success, validator: v => Object.keys(types).includes(v) },
});
</script>
